import React from 'react';
const bonuses = [{
  num: '01',
  title: 'Guía de Supervivencia en la Facultad',
  desc: 'Cómo organizarte desde el primer día, qué estudiar primero y cómo no colapsar con la bibliografía.',
  price: '$12.000'
}, {
  num: '02',
  title: 'Fichas de Autoevaluación por Materia',
  desc: 'Preguntas clave por unidad con respuestas desarrolladas para practicar antes de cada parcial.',
  price: '$9.000'
}, {
  num: '03',
  title: 'Mnemotecnias y Recursos de Memoria',
  desc: 'Técnicas visuales y asociativas para recordar autores, conceptos y teorías en el examen.',
  price: '$10.000'
}, {
  num: '04',
  title: 'Guía de Finales Orales',
  desc: 'Cómo preparar un final oral, qué espera el docente y cómo responder con seguridad y precisión.',
  price: '$9.000'
}, {
  num: '05',
  title: 'Simulacro de Parciales',
  desc: 'Exámenes tipo con las preguntas más frecuentes de cada tomo y sus respuestas modelo.',
  price: '$8.000'
}, {
  num: '06',
  title: 'Cómo Empezar a Ejercer como Psicólogo',
  desc: 'Primeras consultas, encuadre clínico, historia del paciente y orientación para el ejercicio profesional.',
  price: '$10.000'
}];
export function Bonuses() {
  return <section className="relative w-full px-4 sm:px-6 lg:px-8 py-8" style={{
    background: 'linear-gradient(180deg, #FEFAF4 0%, #FDF4E7 50%, #FDF4E7 100%)'
  }} data-id="element-51">
      <div className="mx-auto max-w-4xl" data-id="element-52">

        {/* Heading */}
        <h2 className="text-3xl font-black text-center m-0 mb-1" style={{
        color: '#1E1208'
      }} data-id="element-53">
          Más los{' '}
          <span style={{
          color: '#C8922A'
        }} data-id="element-54">6 Bonos Exclusivos</span>
        </h2>
        <p className="text-center text-sm m-0 mb-6" style={{
        color: '#9A7B5A'
      }} data-id="element-55">
          Armados por psicólogos y docentes — incluidos siempre
        </p>

        {/* Bonus List */}
        <div className="rounded-xl overflow-hidden shadow-sm mb-4" style={{
        border: '1px solid rgba(200,146,42,0.22)'
      }} data-id="element-56">
          {/* Header */}
          <div className="px-5 py-2.5" style={{
          background: 'linear-gradient(135deg, #B8860B 0%, #C8922A 50%, #7A9E7E 100%)'
        }} data-id="element-57">
            <h3 className="text-sm font-black text-white m-0 tracking-wide" data-id="element-58">
              🎁 LOS 6 BONOS — Incluidos siempre
            </h3>
          </div>

          {/* Bonus rows */}
          <div className="divide-y" style={{
          backgroundColor: 'rgba(255,255,255,0.95)',
          borderColor: 'rgba(200,146,42,0.10)'
        }} data-id="element-59">
            {bonuses.map(bonus => <div key={bonus.num} className="flex items-center gap-4 px-5 py-2" style={{
            borderColor: 'rgba(200,146,42,0.10)'
          }} data-id="element-60">
                <span className="shrink-0 text-lg font-black w-8 text-center" style={{
              color: 'rgba(200,146,42,0.35)'
            }} data-id="element-61">
                  {bonus.num}
                </span>
                <div className="flex-1 min-w-0" data-id="element-62">
                  <span className="block text-sm font-black" style={{
                color: '#1E1208'
              }} data-id="element-63">
                    {bonus.title}
                  </span>
                  <span className="block text-xs mt-0.5" style={{
                color: '#9A7B5A'
              }} data-id="element-64">
                    {bonus.desc}
                  </span>
                </div>
                <div className="shrink-0 flex flex-col items-end gap-0.5" data-id="element-65">
                  <span className="text-[10px] line-through" style={{
                color: '#9A7B5A'
              }} data-id="element-66">
                    {bonus.price}
                  </span>
                  <span className="text-[10px] font-black text-white rounded-full px-2 py-0.5" style={{
                background: 'linear-gradient(135deg, #B8860B 0%, #C8922A 100%)'
              }} data-id="element-67">
                    GRATIS
                  </span>
                </div>
              </div>)}
          </div>
        </div>

        {/* Total Value Footer */}
        <div className="text-center rounded-xl px-5 py-3 shadow-sm" style={{
        backgroundColor: 'rgba(200,146,42,0.06)',
        border: '1px solid rgba(200,146,42,0.25)'
      }} data-id="element-68">
          <p className="text-xs font-bold uppercase tracking-widest m-0 mb-1" style={{
          color: '#C8922A'
        }} data-id="element-69">
            Valor total de los 6 Bonos
          </p>
          <div className="flex items-center justify-center gap-3" data-id="element-70">
            <span className="text-base line-through" style={{
            color: '#9A7B5A'
          }} data-id="element-71">
              $58.000
            </span>
            <span className="text-lg font-black" style={{
            color: '#C8922A'
          }} data-id="element-72">
              🎁 GRATIS — Incluidos siempre
            </span>
          </div>
        </div>
      </div>

      {/* Degradé inferior → conecta con Countdown */}
      <div className="absolute bottom-0 left-0 w-full h-16 pointer-events-none" style={{
      background: 'linear-gradient(180deg, transparent 0%, #FDF4E7 100%)'
    }} data-id="element-73" />
    </section>;
}